<template>

  <div class="spinner">
    <span class="content__info">
      Загрузка...
    </span>
    <div class="spinner__image">

      <!-- <?xml version="1.0" encoding="iso-8859-1"?> -->
      <svg height="50px" width="50px" version="1.1" id="Layer_1"
       xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 367.136 367.136" xml:space="preserve">
        <!-- eslint-disable-next-line -->
        <path d="M367.136,149.7V36.335l-39.14,38.953c-13.024-17.561-29.148-32.731-47.732-44.706 c-29.33-18.898-63.352-28.888-98.391-28.888C81.588,1.694,0,83.282,0,183.568s81.588,181.874,181.874,181.874 c34.777,0,68.584-9.851,97.768-28.488c28.394-18.133,51.175-43.703,65.881-73.944l-26.979-13.119 c-25.66,52.77-78.029,85.551-136.669,85.551C98.13,335.442,30,267.312,30,183.568S98.13,31.694,181.874,31.694 c49.847,0,96.439,24.9,124.571,65.042L253.226,149.7H367.136z" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
};
</script>

<style>
  .spinner {

    display: flex;
    flex-direction: column;
    align-items: center;
    height: 50%;
    min-height: 100px;
    gap: 20px;
  }
  .spinner__image {
    width: 50px;
  }
  .spinner__image svg {
    fill: #e14c85b7;
    transform: rotate(0deg);
    animation: rotation 3s linear infinite;
  }

  @keyframes rotation {
    0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
  }
</style>
